<template>
  <div id="app" class="flex flex-col min-h-screen">
    <router-view />
    <WhatsAppFloat />
    <AuthModal v-if="showAuthModal" @close="closeAuthModal" />
  </div>
</template>

<script>
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue'
import AuthModal from '@/components/auth/AuthModal.vue'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'App',
  components: {
    WhatsAppFloat,
    AuthModal
  },
  computed: {
    ...mapGetters('auth', ['showAuthModal'])
  },
  methods: {
    ...mapMutations('auth', ['SET_SHOW_AUTH_MODAL']),
    closeAuthModal() {
      this.SET_SHOW_AUTH_MODAL(false)
    }
  },
  mounted() {
    // Check if user has a valid session on app load
    const token = localStorage.getItem('token')
    if (token) {
      // Verify the token is still valid
      this.$store.dispatch('auth/checkSession').catch(() => {
        // Token is invalid, will be cleared by checkSession
        console.log('Session check failed on app load')
      })
    }
  }
}
</script>

<style>
/* Global styles if needed */
</style>
